module.exports = __webpack_public_path__ + "static/media/whichThinnerThinnersList.feb515d5.mp3";